(function () {
  if (window.__trBuilderCardRotatorBound) return;
  window.__trBuilderCardRotatorBound = true;

  function boolFromData(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    if (typeof value === 'boolean') return value;
    var normalized = String(value).toLowerCase().trim();
    if (normalized === 'true' || normalized === '1') return true;
    if (normalized === 'false' || normalized === '0') return false;
    return fallback;
  }

  function numberFromData(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function appendRetryParam(url) {
    if (!url) return url;
    try {
      var parsed = new URL(url, window.location.href);
      parsed.searchParams.set('tr_retry', String(Date.now()));
      return parsed.toString();
    } catch (error) {
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + 'tr_retry=' + Date.now();
    }
  }

  function tempoBoostFromPercent(percent) {
    var normalized = Math.max(0, Math.min(100, numberFromData(percent, 0))) / 100;
    if (normalized <= 0) return 0;
    return Math.min(1, Math.pow(normalized, 0.75) * 1.35);
  }

  function shuffleInPlace(items) {
    for (var i = items.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }
  }

  function getViewportScale() {
    if (window.visualViewport && Number.isFinite(window.visualViewport.scale)) {
      return window.visualViewport.scale;
    }
    return 1;
  }

  function isCoarseOrTouchContext() {
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return true;
    return (navigator.maxTouchPoints || 0) > 0;
  }

  function initVideoCard(video) {
    if (!video || video.dataset.trBuilderVideoReady === '1') return;
    video.dataset.trBuilderVideoReady = '1';

    var media = video.closest('.tr-collage-card__media') || video.parentElement;
    var retryTimer = null;
    var postPlayCheckTimer = null;
    var autoplayResolutionTimer = null;
    var retryCount = 0;
    var maxRetryCount = 7;
    var retryingSourceUrl = false;
    var awaitingGesture = false;
    var tapOverlay = null;

    function clearRetryTimer() {
      if (!retryTimer) return;
      clearTimeout(retryTimer);
      retryTimer = null;
    }

    function clearPostPlayCheckTimer() {
      if (!postPlayCheckTimer) return;
      clearTimeout(postPlayCheckTimer);
      postPlayCheckTimer = null;
    }

    function clearAutoplayResolutionTimer() {
      if (!autoplayResolutionTimer) return;
      clearTimeout(autoplayResolutionTimer);
      autoplayResolutionTimer = null;
    }

    function ensureTapOverlay() {
      if (tapOverlay || !media) return tapOverlay;

      tapOverlay = document.createElement('button');
      tapOverlay.type = 'button';
      tapOverlay.className = 'tr-video-tap-play';
      tapOverlay.hidden = true;
      tapOverlay.textContent = 'Tap to play';
      tapOverlay.setAttribute('aria-label', 'Tap to play video');
      tapOverlay.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        requestPlay(false, true);
      });

      media.appendChild(tapOverlay);
      return tapOverlay;
    }

    function setTapOverlayVisible(visible) {
      var overlay = ensureTapOverlay();
      if (!overlay) return;
      overlay.hidden = !visible;
      media.classList.toggle('tr-video-needs-tap', visible);
    }

    function shouldAttemptPlayback() {
      if (document.hidden) return false;
      var rect = video.getBoundingClientRect();
      if (rect.width < 2 || rect.height < 2) return false;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      var verticallyVisible = rect.bottom > 0 && rect.top < viewportHeight;
      var horizontallyVisible = rect.right > 0 && rect.left < viewportWidth;
      return verticallyVisible && horizontallyVisible;
    }

    function normalizeVideoState() {
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    function scheduleRetry(delayMs, withReload) {
      if (retryTimer) return;
      if (retryCount >= maxRetryCount) return;
      retryTimer = setTimeout(function () {
        retryTimer = null;
        requestPlay(withReload);
      }, delayMs);
    }

    function schedulePostPlayVerification(delayMs) {
      clearPostPlayCheckTimer();
      postPlayCheckTimer = setTimeout(function () {
        postPlayCheckTimer = null;
        if (!video.paused && !video.ended) return;
        if (video.readyState >= 2) setTapOverlayVisible(true);
        bindGestureRetry();
        scheduleRetry(220, false);
      }, delayMs);
    }

    function scheduleAutoplayResolutionCheck(delayMs) {
      clearAutoplayResolutionTimer();
      autoplayResolutionTimer = setTimeout(function () {
        autoplayResolutionTimer = null;
        if (!video.paused || video.ended) return;
        if (video.readyState >= 2 || retryCount >= 2) {
          setTapOverlayVisible(true);
          bindGestureRetry();
        }
      }, delayMs);
    }

    function retrySourcesWithCacheBust() {
      if (retryingSourceUrl) return false;
      var sourceNodes = video.querySelectorAll('source[src]');
      if (!sourceNodes.length) return false;
      retryingSourceUrl = true;
      sourceNodes.forEach(function (sourceNode) {
        var src = sourceNode.getAttribute('src');
        if (!src) return;
        sourceNode.setAttribute('src', appendRetryParam(src));
      });
      try {
        video.load();
      } catch (error) {}
      return true;
    }

    function bindGestureRetry() {
      if (awaitingGesture) return;
      awaitingGesture = true;

      var onGesture = function () {
        awaitingGesture = false;
        window.removeEventListener('pointerdown', onGesture, true);
        window.removeEventListener('touchstart', onGesture, true);
        window.removeEventListener('keydown', onGesture, true);
        requestPlay(false, true);
      };

      window.addEventListener('pointerdown', onGesture, { once: true, passive: true, capture: true });
      window.addEventListener('touchstart', onGesture, { once: true, passive: true, capture: true });
      window.addEventListener('keydown', onGesture, { once: true, capture: true });
    }

    function requestPlay(withReload, forceAttempt) {
      normalizeVideoState();
      if (!forceAttempt && !shouldAttemptPlayback()) {
        scheduleRetry(260, false);
        scheduleAutoplayResolutionCheck(1800);
        return;
      }
      scheduleAutoplayResolutionCheck(1400);

      if (video.readyState === 0) {
        try {
          video.load();
        } catch (error) {}
      }

      if (withReload) {
        try {
          video.load();
        } catch (error) {}
      }

      retryCount += 1;
      var playPromise = null;

      try {
        playPromise = video.play();
      } catch (error) {
        scheduleRetry(320, true);
        return;
      }

      if (!playPromise || typeof playPromise.then !== 'function') {
        schedulePostPlayVerification(260);
        return;
      }

      playPromise
        .then(function () {
          retryCount = 0;
          clearRetryTimer();
          clearPostPlayCheckTimer();
          clearAutoplayResolutionTimer();
          retryingSourceUrl = false;
          setTapOverlayVisible(false);
          schedulePostPlayVerification(180);
        })
        .catch(function (error) {
          var errorName = error && error.name ? error.name : '';
          if (errorName === 'NotAllowedError') {
            setTapOverlayVisible(true);
            bindGestureRetry();
            scheduleRetry(180, false);
            return;
          }

          if (retrySourcesWithCacheBust()) {
            scheduleRetry(240, false);
            return;
          }

          scheduleRetry(360, true);
        });
    }

    normalizeVideoState();
    var gestureTarget = video.closest('.tr-collage-card') || video;
    video.addEventListener('playing', function () {
      retryCount = 0;
      clearRetryTimer();
      clearPostPlayCheckTimer();
      clearAutoplayResolutionTimer();
      retryingSourceUrl = false;
      setTapOverlayVisible(false);
    });
    gestureTarget.addEventListener('pointerdown', function () {
      requestPlay(false, true);
    }, { passive: true });
    gestureTarget.addEventListener(
      'touchstart',
      function () {
        requestPlay(false, true);
      },
      { passive: true }
    );
    gestureTarget.addEventListener('click', function () {
      requestPlay(false, true);
    });
    video.addEventListener('loadedmetadata', function () {
      requestPlay(false);
    });
    video.addEventListener('loadeddata', function () {
      requestPlay(false);
    });
    video.addEventListener('canplay', function () {
      requestPlay(false);
    });
    video.addEventListener('pause', function () {
      if (video.ended) return;
      scheduleRetry(140, false);
    });
    video.addEventListener('waiting', function () {
      scheduleRetry(220, false);
    });
    video.addEventListener('stalled', function () {
      scheduleRetry(260, true);
    });
    video.addEventListener('error', function () {
      if (retrySourcesWithCacheBust()) {
        scheduleRetry(280, false);
        return;
      }
      scheduleRetry(360, true);
    });
    video.addEventListener('suspend', function () {
      if (!video.paused || video.ended) return;
      scheduleRetry(300, false);
      scheduleAutoplayResolutionCheck(1800);
    });
    video.addEventListener('emptied', function () {
      if (!video.paused || video.ended) return;
      scheduleRetry(320, true);
      scheduleAutoplayResolutionCheck(1800);
    });

    if ('IntersectionObserver' in window) {
      var videoVisibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            requestPlay(false);
          });
        },
        { root: null, threshold: 0.01, rootMargin: '120px 0px' }
      );
      videoVisibilityObserver.observe(video);
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) requestPlay(false);
    });
    window.addEventListener('pageshow', function () {
      requestPlay(false);
    });

    scheduleAutoplayResolutionCheck(2200);
    requestPlay(false);
  }

  function getSyncTextTarget(section, slotKey) {
    if (!section || !slotKey) return null;
    var targets = section.querySelectorAll('[data-tr-sync-text-target="true"]');
    for (var i = 0; i < targets.length; i += 1) {
      if (String(targets[i].dataset.trSyncSlot || '').toLowerCase() === String(slotKey).toLowerCase()) {
        return targets[i];
      }
    }
    return null;
  }

  function readSyncPayloadFromSlide(slide) {
    if (!slide) return null;
    var payloadRoot = slide.querySelector('[data-tr-sync-payload]');
    if (!payloadRoot) return null;
    var bodyNode = payloadRoot.querySelector('[data-tr-sync-body-markup]');
    return {
      eyebrow: payloadRoot.dataset.eyebrow || '',
      heading: payloadRoot.dataset.heading || '',
      buttonLabel: payloadRoot.dataset.buttonLabel || '',
      buttonUrl: payloadRoot.dataset.buttonUrl || '',
      bodyHtml: bodyNode ? bodyNode.innerHTML : ''
    };
  }

  function bodyMarkupHasContent(html) {
    if (!html) return false;
    var probe = document.createElement('div');
    probe.innerHTML = html;
    var text = (probe.textContent || '').replace(/\u00a0/g, ' ').trim();
    if (text) return true;
    return !!probe.querySelector('img, video, iframe');
  }

  function ensureSyncTextDefaults(targetCard) {
    if (!targetCard || targetCard.dataset.trSyncDefaultsReady === '1') return;

    var eyebrowEl = targetCard.querySelector('[data-tr-sync-eyebrow-target]');
    var headingEl = targetCard.querySelector('[data-tr-sync-heading-target]');
    var rteWrapEl = targetCard.querySelector('[data-tr-sync-rte-wrap-target]');
    var rteEl = targetCard.querySelector('[data-tr-sync-rte-target]');
    var buttonEl = targetCard.querySelector('[data-tr-sync-button-target]');

    targetCard.__trSyncDefaults = {
      eyebrow: eyebrowEl ? (eyebrowEl.textContent || '') : '',
      heading: headingEl ? (headingEl.textContent || '') : '',
      bodyHtml: rteEl ? rteEl.innerHTML : '',
      buttonLabel: buttonEl ? (buttonEl.textContent || '') : '',
      buttonUrl: buttonEl ? (buttonEl.getAttribute('href') || '') : ''
    };

    targetCard.dataset.trSyncDefaultsReady = '1';
  }

  function applySyncPayloadToTextCard(targetCard, payload) {
    if (!targetCard || !payload) return;

    ensureSyncTextDefaults(targetCard);
    var defaults = targetCard.__trSyncDefaults || {};

    var eyebrowEl = targetCard.querySelector('[data-tr-sync-eyebrow-target]');
    var headingEl = targetCard.querySelector('[data-tr-sync-heading-target]');
    var rteWrapEl = targetCard.querySelector('[data-tr-sync-rte-wrap-target]');
    var rteEl = targetCard.querySelector('[data-tr-sync-rte-target]');
    var buttonEl = targetCard.querySelector('[data-tr-sync-button-target]');

    var eyebrowText = (payload.eyebrow || '').trim() ? payload.eyebrow : (defaults.eyebrow || '');
    var headingText = (payload.heading || '').trim() ? payload.heading : (defaults.heading || '');
    var bodyHtml = bodyMarkupHasContent(payload.bodyHtml) ? payload.bodyHtml : (defaults.bodyHtml || '');
    var payloadButtonLabel = (payload.buttonLabel || '').trim();
    var payloadButtonUrl = (payload.buttonUrl || '').trim();
    var buttonLabel = payloadButtonLabel ? payload.buttonLabel : '';
    var buttonUrl = payloadButtonLabel ? (payloadButtonUrl || defaults.buttonUrl || '') : '';

    function setElementVisible(element, visible) {
      if (!element) return;
      if (visible) {
        element.removeAttribute('hidden');
        element.style.display = '';
      } else {
        element.setAttribute('hidden', '');
        element.style.display = 'none';
      }
    }

    if (eyebrowEl) {
      eyebrowEl.textContent = eyebrowText;
      setElementVisible(eyebrowEl, Boolean((eyebrowText || '').trim()));
    }

    if (headingEl) {
      headingEl.textContent = headingText;
      setElementVisible(headingEl, Boolean((headingText || '').trim()));
    }

    if (rteEl) {
      rteEl.innerHTML = bodyHtml;
      rteEl.scrollTop = 0;
      initTextCardRte(rteEl);
      rteEl.dispatchEvent(new Event('scroll'));
      if (rteWrapEl) {
        setElementVisible(rteWrapEl, bodyMarkupHasContent(bodyHtml));
      }
    } else if (rteWrapEl) {
      setElementVisible(rteWrapEl, false);
    }

    if (buttonEl) {
      buttonEl.textContent = buttonLabel;
      if (buttonUrl) buttonEl.setAttribute('href', buttonUrl);
      else if (defaults.buttonUrl) buttonEl.setAttribute('href', defaults.buttonUrl);
      setElementVisible(buttonEl, Boolean((buttonLabel || '').trim()));
    }
  }

  function initRotator(container) {
    if (!container || container.dataset.trCardRotatorReady === '1') return;
    container.dataset.trCardRotatorReady = '1';

    var slides = Array.prototype.slice.call(container.querySelectorAll('[data-tr-card-rotator-slide]'));
    if (!slides.length) return;

    var slidesWrap = container.querySelector('.tr-card-rotator__slides');
    var autoplay = boolFromData(container.dataset.autoplay, true);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) autoplay = false;
    var intervalMs = Math.max(1000, numberFromData(container.dataset.intervalMs, 120000));
    var randomStart = boolFromData(container.dataset.randomStart, true);
    var randomSubset = boolFromData(container.dataset.randomSubset, false);
    var maxItems = Math.max(1, numberFromData(container.dataset.maxItems, slides.length));
    var swipeThresholdMobile = numberFromData(container.dataset.swipeThresholdMobile, 40);
    var swipeThresholdDesktop = numberFromData(container.dataset.swipeThresholdDesktop, 50);
    var tempoBoostPercent = Math.max(0, Math.min(100, numberFromData(container.dataset.tempoBoost, 0)));
    var tempoBoost = tempoBoostFromPercent(tempoBoostPercent);
    var mobileSwipeQuery = window.matchMedia('(max-width: 989px)');
    var swipeIntentThreshold = 10;

    var card = container.closest('.tr-collage-card');
    var isContainCard = !!(card && card.classList.contains('tr-collage-card--fit-contain'));
    var resizeRaf = 0;
    var pauseReasons = new Set();
    var advanceTimer = null;
    var tempoRaf = 0;
    var cycleStartAt = 0;
    var cycleElapsedMs = 0;
    var clickPauseTimer = null;
    var suppressClickUntil = 0;
    var currentIndex = 0;

    var syncTextTarget = null;
    if (container.dataset.trSyncSource === 'true') {
      var syncSection = container.closest('.tr-builder-section');
      var syncTargetSlot = String(container.dataset.trSyncTargetSlot || '').trim();
      syncTextTarget = getSyncTextTarget(syncSection, syncTargetSlot);
      ensureSyncTextDefaults(syncTextTarget);
    }

    var touchStartX = 0;
    var touchStartY = 0;
    var touchCurrentX = 0;
    var touchCurrentY = 0;
    var isTouchTracking = false;

    var mouseStartX = 0;
    var mouseStartY = 0;
    var mouseCurrentX = 0;
    var mouseCurrentY = 0;
    var isMouseTracking = false;

    if (randomSubset && slides.length > maxItems && slidesWrap) {
      var shuffledPool = slides.slice();
      shuffleInPlace(shuffledPool);
      var keepSlides = shuffledPool.slice(0, maxItems);
      var keepSet = new Set(keepSlides);

      slides.forEach(function (slide) {
        if (!keepSet.has(slide)) slide.remove();
      });

      keepSlides.forEach(function (slide) {
        slidesWrap.appendChild(slide);
      });

      slides = keepSlides;
    }

    if (randomStart && slides.length > 1) {
      currentIndex = Math.floor(Math.random() * slides.length);
    } else {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i].classList.contains('is-active')) {
          currentIndex = i;
          break;
        }
      }
    }

    if (slides.length < 2) autoplay = false;

    function getContainImageBounds(slide, media, img) {
      if (!slide || !media || !img) return null;

      var slideRect = slide.getBoundingClientRect();
      var mediaRect = media.getBoundingClientRect();
      if (slideRect.width < 2 || slideRect.height < 2 || mediaRect.width < 2 || mediaRect.height < 2) return null;

      var naturalWidth = img.naturalWidth || numberFromData(img.getAttribute('width'), 0);
      var naturalHeight = img.naturalHeight || numberFromData(img.getAttribute('height'), 0);
      var drawLeft = mediaRect.left;
      var drawTop = mediaRect.top;
      var drawWidth = mediaRect.width;
      var drawHeight = mediaRect.height;

      if (naturalWidth > 0 && naturalHeight > 0) {
        var mediaRatio = mediaRect.width / mediaRect.height;
        var imageRatio = naturalWidth / naturalHeight;

        if (imageRatio > mediaRatio) {
          drawWidth = mediaRect.width;
          drawHeight = drawWidth / imageRatio;
          drawTop = mediaRect.top + (mediaRect.height - drawHeight) / 2;
        } else {
          drawHeight = mediaRect.height;
          drawWidth = drawHeight * imageRatio;
          drawLeft = mediaRect.left + (mediaRect.width - drawWidth) / 2;
        }
      }

      var left = Math.max(0, drawLeft - slideRect.left);
      var top = Math.max(0, drawTop - slideRect.top);
      var width = Math.max(0, Math.min(drawWidth, slideRect.width - left));
      var height = Math.max(0, Math.min(drawHeight, slideRect.height - top));
      var bottom = Math.max(0, slideRect.bottom - (drawTop + drawHeight));

      return {
        left: left,
        top: top,
        width: width,
        height: height,
        bottom: bottom
      };
    }

    function getMediaBounds(slide, media) {
      if (!slide || !media) return null;
      var slideRect = slide.getBoundingClientRect();
      var mediaRect = media.getBoundingClientRect();
      if (slideRect.width < 2 || slideRect.height < 2 || mediaRect.width < 2 || mediaRect.height < 2) return null;

      var left = Math.max(0, mediaRect.left - slideRect.left);
      var top = Math.max(0, mediaRect.top - slideRect.top);
      var width = Math.max(0, Math.min(mediaRect.width, slideRect.width - left));
      var height = Math.max(0, Math.min(mediaRect.height, slideRect.height - top));

      return {
        left: left,
        top: top,
        width: width,
        height: height
      };
    }

    function clearContainImageGeometry(img) {
      if (!img) return;
      img.style.left = '';
      img.style.top = '';
      img.style.right = '';
      img.style.bottom = '';
      img.style.width = '';
      img.style.height = '';
      img.style.removeProperty('border-radius');
      img.style.removeProperty('clip-path');
    }

    function applyContainImageGeometry(img, imageBounds) {
      if (!img || !imageBounds) return;
      img.style.setProperty('left', imageBounds.left + 'px', 'important');
      img.style.setProperty('top', imageBounds.top + 'px', 'important');
      img.style.setProperty('right', 'auto', 'important');
      img.style.setProperty('bottom', 'auto', 'important');
      img.style.setProperty('width', imageBounds.width + 'px', 'important');
      img.style.setProperty('height', imageBounds.height + 'px', 'important');
      img.style.setProperty('border-radius', 'var(--tr-card-radius)', 'important');
      img.style.setProperty('clip-path', 'inset(0 round var(--tr-card-radius))', 'important');
    }

    function syncGeometry() {
      slides.forEach(function (slide) {
        var media = slide.querySelector('.tr-collage-card__media');
        var img = slide.querySelector('.tr-collage-card__img');
        var meta = slide.querySelector('.tr-collage-card__meta');
        var tempoTrack = slide.querySelector('.tr-collage-card__tempo');
        var imageBounds = null;
        var alignmentBounds = null;

        if (isContainCard && media && img) {
          imageBounds = getContainImageBounds(slide, media, img);
          if (imageBounds && imageBounds.width >= 2 && imageBounds.height >= 2) {
            applyContainImageGeometry(img, imageBounds);
            alignmentBounds = imageBounds;
          } else {
            clearContainImageGeometry(img);
            alignmentBounds = getMediaBounds(slide, media);
          }
        } else if (img) {
          clearContainImageGeometry(img);
          if (media) alignmentBounds = getMediaBounds(slide, media);
        } else if (media) {
          alignmentBounds = getMediaBounds(slide, media);
        }

        if (meta) {
          if (alignmentBounds && alignmentBounds.width >= 2) {
            var metaInset = 4;
            var alignedWidth = Math.max(0, alignmentBounds.width - metaInset * 2);
            meta.style.width = alignedWidth.toFixed(2) + 'px';
            meta.style.marginLeft = (alignmentBounds.left + metaInset).toFixed(2) + 'px';
            meta.style.marginRight = '0';
          } else {
            meta.style.width = '';
            meta.style.marginLeft = '';
            meta.style.marginRight = '';
          }
        }

        if (!tempoTrack) return;

        var basisWidth = 0;
        if (alignmentBounds && alignmentBounds.width >= 2) {
          basisWidth = alignmentBounds.width;
        } else if (media) {
          var mediaRect = media.getBoundingClientRect();
          basisWidth = mediaRect.width;
        }

        if (basisWidth > 0) {
          var trackWidth = Math.max(42, basisWidth * 0.35);
          tempoTrack.style.width = trackWidth.toFixed(2) + 'px';
        } else {
          tempoTrack.style.width = '';
        }
      });
    }

    function onResize() {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        updateZoomPauseState();
        syncGeometry();
      });
    }

    function setTempoProgress(progress) {
      var normalized = Math.max(0, Math.min(1, progress));
      var fillStartOpacity = 0.18 + tempoBoost * 0.2;
      var fillEndOpacity = 0.8 + tempoBoost * 0.18;
      var trackStartOpacity = 0.08 + tempoBoost * 0.14;
      var trackEndOpacity = 0.16 + tempoBoost * 0.2;
      var trackBaseHeight = 2;
      var trackMaxHeight = 3.2 + tempoBoost * 1.4;
      slides.forEach(function (slide, slideIndex) {
        var fill = slide.querySelector('[data-tr-card-tempo-fill]');
        var track = slide.querySelector('.tr-collage-card__tempo');
        if (!fill) return;
        var isActiveSlide = slideIndex === currentIndex;
        var value = isActiveSlide ? normalized : 0;
        var visibleWidth = isActiveSlide ? Math.max(0.015, value) : 0;

        fill.style.width = (visibleWidth * 100).toFixed(2) + '%';
        fill.style.opacity = (isActiveSlide ? fillStartOpacity + (fillEndOpacity - fillStartOpacity) * value : 0).toFixed(3);

        if (track) {
          var trackHeight = isActiveSlide
            ? trackBaseHeight + (trackMaxHeight - trackBaseHeight) * value
            : trackBaseHeight;
          var trackOpacity = isActiveSlide
            ? trackStartOpacity + (trackEndOpacity - trackStartOpacity) * value
            : trackStartOpacity;
          track.style.height = trackHeight.toFixed(2) + 'px';
          track.style.opacity = trackOpacity.toFixed(3);
        }
      });
    }

    function stopTempoLoop() {
      if (tempoRaf) {
        cancelAnimationFrame(tempoRaf);
        tempoRaf = 0;
      }
    }

    function onTempoFrame(now) {
      if (!autoplay || slides.length < 2 || pauseReasons.size > 0) {
        stopTempoLoop();
        return;
      }

      var elapsed = cycleElapsedMs;
      if (cycleStartAt) elapsed += Math.max(0, now - cycleStartAt);
      setTempoProgress(elapsed / intervalMs);
      tempoRaf = requestAnimationFrame(onTempoFrame);
    }

    function startTempoLoop() {
      stopTempoLoop();
      if (!autoplay || slides.length < 2 || pauseReasons.size > 0) return;
      tempoRaf = requestAnimationFrame(onTempoFrame);
    }

    function clearAdvanceTimer() {
      if (advanceTimer) {
        clearTimeout(advanceTimer);
        advanceTimer = null;
      }
    }

    function captureCycleElapsed() {
      if (!cycleStartAt) return;
      cycleElapsedMs += Math.max(0, performance.now() - cycleStartAt);
      if (cycleElapsedMs > intervalMs) cycleElapsedMs = intervalMs;
      cycleStartAt = 0;
    }

    function canChangeSlides() {
      if (!isCoarseOrTouchContext()) return true;
      return getViewportScale() <= 1.01;
    }

    function scheduleAdvance() {
      clearAdvanceTimer();
      stopTempoLoop();

      if (!autoplay || slides.length < 2 || pauseReasons.size > 0) return;

      if (cycleElapsedMs >= intervalMs) cycleElapsedMs = 0;
      cycleStartAt = performance.now();
      startTempoLoop();

      var remaining = Math.max(50, intervalMs - cycleElapsedMs);
      advanceTimer = setTimeout(function () {
        cycleElapsedMs = 0;
        cycleStartAt = 0;
        setActive(currentIndex + 1);
      }, remaining);
    }

    function addPauseReason(reason) {
      if (pauseReasons.has(reason)) return;
      pauseReasons.add(reason);
      captureCycleElapsed();
      clearAdvanceTimer();
      stopTempoLoop();
      setTempoProgress(cycleElapsedMs / intervalMs);
    }

    function removePauseReason(reason) {
      if (!pauseReasons.has(reason)) return;
      pauseReasons.delete(reason);

      if (reason !== 'zoom') updateZoomPauseState();
      if (pauseReasons.size === 0) scheduleAdvance();
    }

    function pauseOnClickTemporarily(ms) {
      addPauseReason('click');
      if (clickPauseTimer) clearTimeout(clickPauseTimer);
      clickPauseTimer = setTimeout(function () {
        clickPauseTimer = null;
        removePauseReason('click');
      }, ms);
    }

    function updateZoomPauseState() {
      if (!autoplay || slides.length < 2) return;
      if (canChangeSlides()) removePauseReason('zoom');
      else addPauseReason('zoom');
    }

    function prioritizeSlideImage(slide, fetchPriority) {
      if (!slide) return;
      var img = slide.querySelector('.tr-collage-card__img');
      if (!img) return;

      // Promote deferred slide before paint.
      // Slides rendered with data-src are placeholders to prevent the preload
      // scanner from fetching hidden rotator images on page load.
      if (img.dataset.src) {
        if (img.dataset.sizes) img.sizes = img.dataset.sizes;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-sizes');
      }

      img.setAttribute('loading', 'eager');
      img.loading = 'eager';

      if (fetchPriority) {
        img.setAttribute('fetchpriority', fetchPriority);
        try {
          img.fetchPriority = fetchPriority;
        } catch (error) {}
      }

      if (typeof img.decode === 'function' && !img.complete) {
        img.decode().catch(function () {});
      }
    }

    function setActive(index) {
      if (!slides.length) return;

      if (index >= slides.length) currentIndex = 0;
      else if (index < 0) currentIndex = slides.length - 1;
      else currentIndex = index;

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        var link = slide.querySelector('.tr-collage-card__link');
        if (link) {
          if (isActive) link.removeAttribute('tabindex');
          else link.setAttribute('tabindex', '-1');
        }
      });

      prioritizeSlideImage(slides[currentIndex], 'high');
      if (slides.length > 1) {
        var nextIndex = (currentIndex + 1) % slides.length;
        prioritizeSlideImage(slides[nextIndex], 'low');
      }

      syncGeometry();
      if (syncTextTarget) {
        applySyncPayloadToTextCard(syncTextTarget, readSyncPayloadFromSlide(slides[currentIndex]));
      }
      cycleElapsedMs = 0;
      setTempoProgress(0);
      scheduleAdvance();
    }

    function next() {
      if (!canChangeSlides()) return false;
      setActive(currentIndex + 1);
      return true;
    }

    function prev() {
      if (!canChangeSlides()) return false;
      setActive(currentIndex - 1);
      return true;
    }

    function maybeTriggerSwipe(deltaX, deltaY) {
      var swipeThreshold = mobileSwipeQuery.matches ? swipeThresholdMobile : swipeThresholdDesktop;
      if (Math.abs(deltaX) >= swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX < 0) return next();
        return prev();
      }
      return false;
    }

    function onTouchStart(event) {
      if (slides.length < 2) return;
      if (event.touches.length !== 1) return;
      if (!canChangeSlides()) return;

      var touch = event.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchCurrentX = touch.clientX;
      touchCurrentY = touch.clientY;
      isTouchTracking = true;
      addPauseReason('touch');
    }

    function onTouchMove(event) {
      if (!isTouchTracking) return;
      if (event.touches.length !== 1) return;
      if (!canChangeSlides()) return;

      var touch = event.touches[0];
      touchCurrentX = touch.clientX;
      touchCurrentY = touch.clientY;

      var deltaX = touchCurrentX - touchStartX;
      var deltaY = touchCurrentY - touchStartY;
      if (Math.abs(deltaX) > swipeIntentThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        event.preventDefault();
      }
    }

    function onTouchEnd() {
      if (!isTouchTracking) return;

      var deltaX = touchCurrentX - touchStartX;
      var deltaY = touchCurrentY - touchStartY;
      var didSwipe = maybeTriggerSwipe(deltaX, deltaY);
      if (didSwipe) suppressClickUntil = Date.now() + 350;

      isTouchTracking = false;
      setTimeout(function () {
        removePauseReason('touch');
      }, 80);
    }

    function onTouchCancel() {
      isTouchTracking = false;
      removePauseReason('touch');
    }

    function isInteractiveTarget(target) {
      return Boolean(target && target.closest('button, input, select, textarea, summary, details'));
    }

    function onMouseDown(event) {
      if (slides.length < 2) return;
      if (event.button !== 0) return;
      if (isInteractiveTarget(event.target)) return;
      if (!canChangeSlides()) return;

      isMouseTracking = true;
      mouseStartX = event.clientX;
      mouseStartY = event.clientY;
      mouseCurrentX = event.clientX;
      mouseCurrentY = event.clientY;
      addPauseReason('pointer');
      container.classList.add('tr-dragging');

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
      window.addEventListener('blur', onMouseUp);
    }

    function onMouseMove(event) {
      if (!isMouseTracking) return;
      mouseCurrentX = event.clientX;
      mouseCurrentY = event.clientY;

      var deltaX = mouseCurrentX - mouseStartX;
      var deltaY = mouseCurrentY - mouseStartY;
      if (Math.abs(deltaX) > swipeIntentThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        event.preventDefault();
      }
    }

    function onMouseUp() {
      if (!isMouseTracking) return;

      var deltaX = mouseCurrentX - mouseStartX;
      var deltaY = mouseCurrentY - mouseStartY;
      var didSwipe = maybeTriggerSwipe(deltaX, deltaY);
      if (didSwipe) suppressClickUntil = Date.now() + 350;

      isMouseTracking = false;
      container.classList.remove('tr-dragging');
      removePauseReason('pointer');

      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('blur', onMouseUp);
    }

    function onContainerClickCapture(event) {
      if (Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (autoplay && slides.length > 1) pauseOnClickTemporarily(2500);
    }

    function onFocusOut() {
      setTimeout(function () {
        if (!container.contains(document.activeElement)) removePauseReason('focus');
      }, 0);
    }

    function onSyncTargetFocusOut() {
      if (!syncTextTarget) return;
      setTimeout(function () {
        if (!syncTextTarget.contains(document.activeElement)) removePauseReason('sync-focus');
      }, 0);
    }

    if (slides.length > 1) {
      container.classList.add('tr-drag-enabled');
      container.addEventListener('touchstart', onTouchStart, { passive: true });
      container.addEventListener('touchmove', onTouchMove, { passive: false });
      container.addEventListener('touchend', onTouchEnd, { passive: true });
      container.addEventListener('touchcancel', onTouchCancel, { passive: true });
      container.addEventListener('mousedown', onMouseDown);
      container.addEventListener('click', onContainerClickCapture, true);
    }

    slides.forEach(function (slide) {
      var slideLink = slide.querySelector('.tr-collage-card__link');
      if (!slideLink) return;
      slideLink.setAttribute('draggable', 'false');
      slideLink.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
    });

    container.addEventListener('mouseenter', function () {
      addPauseReason('hover');
    });
    container.addEventListener('mouseleave', function () {
      removePauseReason('hover');
    });
    container.addEventListener('focusin', function () {
      addPauseReason('focus');
    });
    container.addEventListener('focusout', onFocusOut);

    if (syncTextTarget) {
      syncTextTarget.addEventListener('mouseenter', function () {
        addPauseReason('sync-hover');
      });
      syncTextTarget.addEventListener('mouseleave', function () {
        removePauseReason('sync-hover');
      });
      syncTextTarget.addEventListener('focusin', function () {
        addPauseReason('sync-focus');
      });
      syncTextTarget.addEventListener('focusout', onSyncTargetFocusOut);
    }

    slides.forEach(function (slide) {
      var img = slide.querySelector('.tr-collage-card__img');
      if (!img) return;
      if (!img.complete) {
        img.addEventListener('load', syncGeometry);
      }
      img.addEventListener('error', function () {
        if (img.dataset.trImageRetry === '1') return;
        var retryUrl = img.currentSrc || img.getAttribute('src');
        if (!retryUrl) return;

        img.dataset.trImageRetry = '1';
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
        try {
          img.fetchPriority = 'high';
        } catch (error) {}
        img.removeAttribute('srcset');
        img.src = appendRetryParam(retryUrl);
      });
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateZoomPauseState);
      window.visualViewport.addEventListener('scroll', updateZoomPauseState);
    }

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            requestAnimationFrame(function () {
              prioritizeSlideImage(slides[currentIndex], 'high');
              syncGeometry();
            });
          });
        },
        { root: null, threshold: 0.01, rootMargin: '120px 0px' }
      );
      visibilityObserver.observe(container);
    }

    window.addEventListener('resize', onResize);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) addPauseReason('hidden');
      else removePauseReason('hidden');
    });

    setActive(currentIndex);
    syncGeometry();
    updateZoomPauseState();
    if (pauseReasons.size === 0) scheduleAdvance();
  }

  function initTextCardRte(rte) {
    if (!rte || rte.dataset.trRteCueReady === '1') return;
    rte.dataset.trRteCueReady = '1';
    var cueHost = rte.closest('.tr-collage-card__rte-wrap') || rte;
    var isAndroidPlatform = /Android/i.test((navigator && navigator.userAgent) || '');
    var isTouchCapablePlatform =
      (navigator && Number(navigator.maxTouchPoints || 0) > 0) ||
      ('ontouchstart' in window) ||
      (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    var interactionTimer = null;

    if (cueHost && (isAndroidPlatform || isTouchCapablePlatform)) {
      cueHost.classList.add('tr-rte-platform-touch');
    }

    function setInteractingState() {
      if (!cueHost) return;
      cueHost.classList.add('tr-rte-interacting');
      if (interactionTimer) clearTimeout(interactionTimer);
      interactionTimer = setTimeout(function () {
        cueHost.classList.remove('tr-rte-interacting');
        interactionTimer = null;
      }, 700);
    }

    function syncRteCueState() {
      var maxScrollTop = Math.max(0, rte.scrollHeight - rte.clientHeight);
      var isScrollable = maxScrollTop > 2;
      var isAtBottom = isScrollable && rte.scrollTop >= maxScrollTop - 2;
      var hasScrolled = rte.scrollTop > 2;

      rte.classList.toggle('tr-rte-scrollable', isScrollable);
      rte.classList.toggle('tr-rte-at-bottom', isAtBottom);
      rte.classList.toggle('tr-rte-has-scrolled', hasScrolled);
      if (cueHost && cueHost !== rte) {
        cueHost.classList.toggle('tr-rte-scrollable', isScrollable);
        cueHost.classList.toggle('tr-rte-at-bottom', isAtBottom);
        cueHost.classList.toggle('tr-rte-has-scrolled', hasScrolled);
      }
    }

    rte.addEventListener(
      'scroll',
      function () {
        setInteractingState();
        syncRteCueState();
      },
      { passive: true }
    );
    rte.addEventListener('touchstart', setInteractingState, { passive: true });
    rte.addEventListener('pointerdown', setInteractingState, { passive: true });
    window.addEventListener('resize', syncRteCueState);

    if ('ResizeObserver' in window) {
      new ResizeObserver(syncRteCueState).observe(rte);
    }

    requestAnimationFrame(syncRteCueState);
    setTimeout(syncRteCueState, 220);
    setTimeout(syncRteCueState, 800);
  }

  function initAll(root) {
    var scope = root || document;
    var rotators = scope.querySelectorAll('[data-tr-card-rotator]');
    var videos = scope.querySelectorAll('.tr-slot--type-video video, video[data-tr-builder-video]');
    var rtes = scope.querySelectorAll('.tr-collage-card__rte');
    rotators.forEach(initRotator);
    videos.forEach(initVideoCard);
    rtes.forEach(initTextCardRte);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
